export {default} from './BaseScreen.connect';
